module.exports = __webpack_public_path__ + "static/media/sivil-toplum-logo.1fb884fa.png";